const  DialogStyles = () => {
  return {
    styleOverrides: {
      paper: {
        backgroundColor: "var(--Schemes-Surface)",
        minWidth: "344px",
        maxHeight: "608px",
        borderRadius: "12px",
        boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
        border: "1px solid var(--Schemes-Outline-Variant)"
      },
      root: {
        "& .MuiDialogContent-root": {
          padding: "8px"
        }
      }
    }
  }
}
export default DialogStyles